export default "f7722c47653c04ba.svg"